import React, { useState, useEffect } from 'react';
import { clientAPI } from '../../services/api';
import './ClientProjects.css';

export default function ClientProjects() {
  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(true);
  const [expandedProject, setExpandedProject] = useState(null);
  const [versions, setVersions] = useState({});

  useEffect(() => {
    loadProjects();
  }, []);

  const loadProjects = async () => {
    try {
      const response = await clientAPI.getProjects();
      setProjects(response.data.projects);
    } catch (error) {
      alert('Failed to load projects');
    } finally {
      setLoading(false);
    }
  };

  const loadVersions = async (projectId) => {
    if (versions[projectId]) {
      setExpandedProject(expandedProject === projectId ? null : projectId);
      return;
    }

    try {
      const response = await clientAPI.getVersions(projectId);
      setVersions({ ...versions, [projectId]: response.data.versions });
      setExpandedProject(projectId);
    } catch (error) {
      alert('Failed to load versions');
    }
  };

  const handleDownload = (versionId, fileName) => {
    const token = localStorage.getItem('token');
    // window.open(`http://localhost:5000/api/client/download/${versionId}?token=${token}`, '_blank');
    window.open(`https://nextgentechies.sbs/siju_portal/client/download/${versionId}?token=${token}`, '_blank');
  };

  const formatFileSize = (bytes) => {
    if (bytes === 0) return '0 Bytes';
    const k = 1024;
    const sizes = ['Bytes', 'KB', 'MB', 'GB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return Math.round(bytes / Math.pow(k, i) * 100) / 100 + ' ' + sizes[i];
  };

  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    });
  };

  if (loading) return <div className="client-projects-loading">Loading projects</div>;

  return (
    <div className="client-projects-container">
      <div className="client-projects-header">
        <h1>My Projects</h1>
        <p>Access your project files and manage downloads</p>
      </div>

      {projects.length === 0 ? (
        <div className="client-projects-empty">
          <div className="client-projects-empty-icon">📦</div>
          <h2>No Projects Yet</h2>
          <p>No projects have been assigned to your account. Please contact your administrator.</p>
        </div>
      ) : (
        <div className="client-projects-grid">
          {projects.map(project => (
            <div key={project.id} className="client-project-card">
              <div className="client-project-card-header">
                <h3 className="client-project-title">{project.title}</h3>
                {project.description && (
                  <p className="client-project-description">{project.description}</p>
                )}
              </div>

              <div className="client-project-body">
                <div className="client-project-meta">
                  <div className="client-project-meta-item">
                    <span className="client-project-meta-label">Platform</span>
                    <span className="client-project-meta-value">{project.platform || 'Multi'}</span>
                  </div>
                  <div className="client-project-meta-item">
                    <span className="client-project-meta-label">Versions</span>
                    <span className="client-project-meta-value">{project.version_count}</span>
                  </div>
                </div>

                <div className="client-project-footer">
                  <button
                    onClick={() => loadVersions(project.id)}
                    className="client-expand-btn"
                  >
                    <span>{expandedProject === project.id ? '▼' : '▶'}</span>
                    <span>{expandedProject === project.id ? 'Hide Versions' : 'View Versions'}</span>
                  </button>

                  {expandedProject === project.id && versions[project.id] && (
                    <div className="client-versions-container">
                      <h4 className="client-versions-title">Available Versions</h4>
                      {versions[project.id].length === 0 ? (
                        <p style={{ textAlign: 'center', color: '#718096', padding: '16px' }}>
                          No versions available
                        </p>
                      ) : (
                        <div className="client-version-list">
                          {versions[project.id].map(version => (
                            <div key={version.id} className="client-version-item">
                              <div className="client-version-info">
                                <div className="client-version-label">v{version.version}</div>
                                <div className="client-version-date">Released {formatDate(version.created_at)}</div>
                                <div className="client-version-file-info">
                                  {version.file_name} • {formatFileSize(version.file_size)}
                                </div>
                              </div>
                              <button
                                onClick={() => handleDownload(version.id, version.file_name)}
                                className="client-download-btn"
                              >
                                ⬇ Download
                              </button>
                            </div>
                          ))}
                        </div>
                      )}
                    </div>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
